import React from 'react';

interface Props {
    name: string;
    className?: string;
    onClick?: () => void;
}
const MaterialIcon = (props: Props) => {

    return (
        <React.Fragment>
            <div id="MaterialIcon" className={`material-symbols-outlined ${props.className}`} onClick={props.onClick}>
                {props.name}
            </div>
        </React.Fragment>
    );
}

export default MaterialIcon;